import React, { useEffect } from 'react';
import { UserData } from '../types';
import { supabase } from '../services/supabaseClient';

interface PendingApprovalViewProps {
  user: UserData;
  onLogout: () => void;
}

const PendingApprovalView: React.FC<PendingApprovalViewProps> = ({ user, onLogout }) => {

  useEffect(() => {
    // Poll the server every 5 seconds to check if the user has been approved by admin
    const interval = setInterval(async () => {
      const { data: { user: authUser } } = await supabase.auth.getUser();
      if (authUser) {
        const { data } = await supabase.from('profiles').select('is_approved').eq('id', authUser.id).single();
        if (data?.is_approved) {
          // If approved, force a hard reload of the page to rebuild the React tree and enter Dashboard
          window.location.reload();
        }
      }
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-[#020617] flex items-center justify-center p-6 relative overflow-hidden">
      {/* Background Aurora Effects */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute top-[-20%] left-[-10%] w-[70%] h-[70%] bg-indigo-600/10 rounded-full blur-[140px] animate-pulse"></div>
        <div className="absolute bottom-[-20%] right-[-10%] w-[70%] h-[70%] bg-blue-600/10 rounded-full blur-[140px] animate-pulse" style={{animationDelay: '3s'}}></div>
      </div>

      <div className="w-full max-w-2xl relative z-10 animate-in fade-in slide-in-from-bottom-8 duration-1000">
        <div className="bg-white/5 backdrop-blur-3xl p-10 md:p-16 rounded-[3.5rem] shadow-[0_32px_64px_-16px_rgba(0,0,0,0.6)] border border-white/10 text-center relative overflow-hidden group">
          
          <div className="w-24 h-24 bg-gradient-to-br from-indigo-500/20 to-indigo-700/20 rounded-[2rem] flex items-center justify-center shadow-inner mx-auto mb-8 border border-indigo-500/30">
            <span className="text-5xl animate-bounce">⏳</span>
          </div>
          
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4 italic tracking-tighter">Cont În Așteptare</h2>
          
          <div className="space-y-6 text-slate-300 font-medium leading-relaxed italic mb-10 text-sm md:text-base">
            <p>
              Bună, <strong className="text-white not-italic">{user.name}</strong>. Îți mulțumim pentru interesul acordat LexSmart AI!
            </p>
            <p>
              Deoarece platforma noastră se află în faza de <strong>Closed Beta</strong> și oferim acces la instrumente analitice avansate exclusiv pentru avocați, fiecare cont este verificat manual.
            </p>
            <p className="bg-indigo-500/10 border border-indigo-500/20 p-4 rounded-2xl text-indigo-200 text-xs md:text-sm">
              Echipa noastră verifică în acest moment apartenența la baroul declarat ({user.bar}). Procesul durează de obicei între 2 și 24 de ore lucrătoare.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-8 border-t border-white/5">
            <button 
              onClick={onLogout}
              className="px-8 py-4 bg-white/5 hover:bg-white/10 text-white rounded-2xl font-black text-[10px] uppercase tracking-[0.2em] transition-all border border-white/10 w-full sm:w-auto"
            >
              Deconectare
            </button>
            <a 
              href="mailto:suport@lexsmart.ro"
              className="px-8 py-4 bg-indigo-600 hover:bg-indigo-700 text-white rounded-2xl font-black text-[10px] uppercase tracking-[0.2em] transition-all shadow-lg shadow-indigo-600/20 w-full sm:w-auto text-center"
            >
              Contact Suport
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingApprovalView;